<ng-container>
	<base-display #display [alignment]="'right'" [smallLetters]="" [bigLetters]="b()" [unit]="''"></base-display>
</ng-container>
